import { DatePicker, Input, Table, Icon, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const settlementStatusCode = ['ALL', 'PENDING', 'COIN', 'CASH'];
const settlementStatusString = {
  ALL: '전체보기',
  PENDING: '미정산',
  COIN: '완료(코인)',
  CASH: '완료(현금)',
}
class RomarketPaymentSettlement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      startDate: '',
      endDate: '',
      status: 'ALL',
      userIdx: '',
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.romarketPaymentSettlementList,[10,pageNum,this.state.startDate,this.state.endDate,this.state.status,this.state.userIdx],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };
  handleChangeDate = (value) => {
    if (value.length == 0) {
      this.setState({
        startDate: "",
        endDate: "",
      }, this.getList);
    }
    else {
      this.setState({
        startDate: value[0].format('YYYYMMDD'),
        endDate: value[1].format('YYYYMMDD'),
      }, this.getList);

    }
  };
  onStatus = (value) => {
    this.setState(
      {
        status: value
      },
      () => {
        this.getList();
      }
    );
  };

  settlementCoin = () => {
    global.confirm('코인으로 정산하는경우 상점으로 코인이 지급됩니다. 정산하시겠습니까?')
  }
  settlementCash = () => {
    global.confirm('현금으로 정산완료 된것으로 처리하시겠습니까?')
  }

  downloadExcel = () => {
    // const {
    //   coinType,
    //   pagination,
    //   searchText,
    //   orderType,
    //   orderByType
    // } = this.state;
    // const coinList = reactLocalStorage.getObject("coinList");

    // if (coinType === 0 || coinType === undefined) {
    //   alert("코인 종류를 선택해주세요.");
    // } else {
    //   // console.log(`${excelFormat(startDate)} ~ ${excelFormat(endDate)}`);
    //   httpDownload(httpUrl.foundationLockExcel, [
    //     pagination.total,
    //     1,
    //     coinType,
    //     searchText,
    //     orderType,
    //     orderByType
    //   ])
    //     .then((res) => {
    //       // console.log(JSON.stringify(res, null, 4));
    //       fileDownload(
    //         res,
    //         `${
    //           coinList.find((coin) => coin.coinType === coinType).name
    //         } LOCK 관리.xlsx`
    //       );
    //     })
    //     .catch((error) => {});
    // }
  };
  render() {
    const { tables } = this.state;
    
    const columns = [
      {
        title: "정산일",
        dataIndex: "statDate",
        className: "support-column-number fs-15 lh-21",
        render: value => moment(value, 'YYYYMMDD').format('YYYY-MM-DD') // 날짜 형식을 변환
      },
      {
        title: "상점 ID",
        dataIndex: "infFranchiseId",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "결제금액(원)",
        dataIndex: "coinPrice",
        className: "support-column-number fs-15 lh-21",
        render: (value, row) => <div style={{color: row.canceled == 1 ? 'red' : ''}}>{numberFormat(value * (row.canceled == 1 ? -1 : 1))}</div>
      },
      {
        title: "결제수량(ROM)",
        dataIndex: "payAmount",
        className: "support-column-number fs-15 lh-21",
        render: (value, row) => <div style={{color: row.canceled == 1 ? 'red' : ''}}>{value ? (value * (row.canceled == 1 ? -1 : 1)/1000000000).toFixed(4) : ''}</div>
      },
      {
        title: "코인단가(원)",
        dataIndex: "payUnitPrice",
        className: "support-column-number fs-15 lh-21",
        render: (value, row) => (row.coinPrice/(row.payAmount/1000000000)).toFixed(2) // 소수점 두 자리까지 표시
      },
      {
        title: "취소건",
        dataIndex: "canceled",
        className: "support-column-number fs-15 lh-21 font-red",
        render: value => value === 0 ? "" : "취소" // 0은 '아니오', 그 외는 '예'
      },
      {
        title: "상태",
        dataIndex: "status",
        className: "support-column-number fs-15 lh-21",
        render: value => settlementStatusString[value]
      },
      {
        title: "정산처리",
        dataIndex: "status",
        className: "support-column-number fs-15 lh-21",
        render: (value, row) => {
          if (value == 'PENDING') {
            return (
              <div>
                <Button onClick={this.settlementCoin}>코인정산</Button>
                <Button style={{marginLeft: '10px'}} onClick={this.settlementCash}>현금정산</Button>
              </div>
            )
          }
        }
      },
      {
        title: "메모",
        dataIndex: "memo",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? value : "없음" // null 값 처리
      }
    ];
    
    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className="flex-row flex-center" style={{paddingBottom: '10px'}}>
              <RangePicker
                  locale={locale}
                  onChange={(date) => {
                    this.handleChangeDate(date);
                  }}
                />
                <div style={{paddingLeft: '20px'}}>상태:</div>
                <SelectBox
                  value={settlementStatusString[this.state.status]}
                  code={settlementStatusCode}
                  codeString={settlementStatusString}
                  onChange={(value) => {
                    if (value !== this.state.status) {
                      this.onStatus(value);
                    }
                  }}
                  style={{ width: "200px", marginLeft: "10px" }}
                />
            </div>
            <Button onClick={this.downloadExcel}>
              <Icon type="download" style={{ fontSize: "20px" }} />
              EXCEL
            </Button>
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.status == 'PENDING' ? "" : "gray")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default RomarketPaymentSettlement;
